/**
 * Die Auswahl der Art (`tenant-create-legal-form` / `tenant-edit-legal-form`,
 * Spec 03, „Sheet Mieter anlegen" / „Reiter Stammdaten eines Mieters"). Die
 * Optionen kommen von `GET /tenants/legal-forms` — der Client pflegt keine
 * eigene Zuordnung von Werten auf deutsche Bezeichnungen (I9).
 *
 * Die Darstellung liegt in `components/EnumSelectField`; hier bleibt nur, was
 * fachlich ist: die Abfrage und die Beschriftung.
 */

import { useLegalForms } from '@/features/tenants/api'
import { EnumSelectField } from '@/components/EnumSelectField'
import type { FieldError } from '@/components/FormField'

interface LegalFormFieldProps {
  readonly testId: string
  readonly errorPrefix: string
  readonly value: string
  readonly onChange: (value: string) => void
  readonly error: FieldError | undefined
  readonly disabled?: boolean
}

export function LegalFormField({
  testId,
  errorPrefix,
  value,
  onChange,
  error,
  disabled = false,
}: LegalFormFieldProps) {
  const legalFormsQuery = useLegalForms()

  return (
    <EnumSelectField
      label="Art"
      testId={testId}
      apiField="legal_form"
      errorPrefix={errorPrefix}
      options={legalFormsQuery.data ?? []}
      isPending={legalFormsQuery.isPending}
      value={value}
      onChange={onChange}
      error={error}
      disabled={disabled}
    />
  )
}
